export default __webpack_public_path__ + "static/media/profileDefault.e8fef4bc.svg";